// Constantes de dominio del módulo admin (panel de soporte/ejecución de acciones
// sobre facturas y prefacturas de un colaborador).

// Módulos sobre los que opera el panel. Los mismos valores se usan como "tipo"
// al descargar (PreFacturas vs Facturas).
export const ADMIN_MODULE = {
  INVOICES: "Facturas",
  PRE_INVOICES: "PreFacturas",
} as const;

// Acciones disponibles por módulo.
export const ADMIN_ACTION = {
  GENERATE: "Generar",
  CONSULT: "Consultar",
  SEND: "Enviar",
} as const;

// Estados de factura/prefactura que el panel compara (enum estable del backend).
export const DOC_STATUS = {
  CREATED: "CREATED",
  CANCELLED: "CANCELLED",
} as const;

// Colores de los diálogos de confirmación (sweetalert2).
export const SWAL_COLOR = { CONFIRM: "#3085d6", CANCEL: "#d33", DENY: "#049942" };

// Color de fondo del chip de acción "Enviar".
export const SEND_CHIP_COLOR = "#4bd86d";

// Códigos de estado que el backend devuelve en el body (statusCode) y en el code
// de error. 100 = info, 200 = ok, 400 = error de validación.
export const HTTP_STATUS = { SUCCESS: 200, INFO: 100, BAD_REQUEST: 400 };

// Tipos derivados de las constantes: los valores literales son el dominio real.
export type AdminModule = (typeof ADMIN_MODULE)[keyof typeof ADMIN_MODULE];
export type AdminAction = (typeof ADMIN_ACTION)[keyof typeof ADMIN_ACTION];
